import { useEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { CodesProvider } from "./lib/CodesContext";
import { LeadProvider } from "./lib/LeadContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";
import AdminModal from "./components/AdminModal";

const Home = lazy(() => import("./pages/Home"));
const Informacoes = lazy(() => import("./pages/Informacoes"));
const Renovacao = lazy(() => import("./pages/Renovacao"));
const Download = lazy(() => import("./pages/Download"));

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <CodesProvider>
      <LeadProvider>
      <BrowserRouter>
        <ScrollToTop />
        <div className="min-h-screen bg-ink-950 font-sans text-slate-50">
          <div className="grain" aria-hidden="true" />
          <Header />
          <main>
            <Suspense fallback={<div className="min-h-[100svh] bg-ink-950" />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/informacoes" element={<Informacoes />} />
                <Route path="/renovacao" element={<Renovacao />} />
                <Route path="/download" element={<Download />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <FloatingWhatsApp />
          <AdminModal />
          <Toaster
            position="bottom-center"
            theme="dark"
            toastOptions={{
              style: {
                background: "#0f131d",
                border: "1px solid rgba(163,230,53,0.25)",
                color: "#f8fafc",
              },
            }}
          />
        </div>
      </BrowserRouter>
      </LeadProvider>
    </CodesProvider>
  );
}

export default App;
